/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef, useState } from "react";
import { Button, Card, Dropdown, Image } from "antd";
import { useAppSelector } from "../../../../../../../config/hooks";

import SimpleService from "./SimpleService";
import LineItems from "./LineItems";
import ServicesWithSub from "./SurviceWithSub";
import InnerCard from "../InnerCard";
import { calculateServiceIntervals } from "../Utils";
import { DeleteIcon } from "../../../../../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";
import { PopUp } from "../../../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../../../atoms/ConfirmDelete";
import MatItems from "./MatItems";

export default function EstimateServices(props: any) {
  const {
    setActiveRecord,
    setActiveType,
    groupData,
    groupedData,
    setGroupedData,
    groupIndex,
    companyId,
    apiData,
    setActiveServiceLineId,
    setActiveServiceId,
    setSelectedServiceIds,
    selectedServiceIds,
    setEstimateChanges,
  } = props;

  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );

  // let totalServiceLineCost = 0;
  // let totalServiceLinePrice = 0;

  // groupedData?.forEach((item: any) => {
  //   if (item?.service_line_id === groupData?.service_line_id) {
  //     (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
  //       serviceGroup?.services?.forEach((service: any) => {
  //         totalServiceLineCost += service?.total_cost || 0;
  //         totalServiceLinePrice += service?.total_price || 0;
  //       });
  //     });

  //     // Calculate total cost from top-level services
  //     (groupData?.services ?? []).forEach((service: any) => {
  //       totalServiceLineCost += service?.total_cost || 0;
  //       totalServiceLinePrice += service?.total_price || 0;
  //     });

  //     (groupData?.line_items ?? []).forEach((items: any) => {
  //       totalServiceLineCost += items?.total_cost || 0;
  //       totalServiceLinePrice += items?.total_price || 0;
  //     });
  //   }
  // });

  // useEffect(() => {
  //   setGroupedData((prevData: any) => {
  //     return prevData.map((item: any) => {
  //       if (item.service_line_id === groupData?.service_line_id) {
  //         return {
  //           ...item,
  //           total_cost: totalServiceLineCost,
  //           total_price: totalServiceLinePrice,
  //           labor_rate: inputData?.labor_rate,
  //           gross_margin_perc: +inputData?.service_line_gm,
  //           service_groups: item?.service_groups?.map((serviceGroup: any) => {
  //             return {
  //               ...serviceGroup,
  //               total_cost: serviceGroup?.services?.reduce(
  //                 (sum: number, service: any) => sum + service?.total_cost || 0,
  //                 0
  //               ),
  //               total_price: serviceGroup?.services?.reduce(
  //                 (sum: number, service: any) =>
  //                   sum + service?.total_price || 0,
  //                 0
  //               ),
  //               gross_margin_perc: +inputData?.subservice_gm || 0,
  //             };
  //           }),
  //         };
  //       }
  //       return item;
  //     });
  //   });
  // }, [inputData, totalServiceLineCost, totalServiceLinePrice]);

  const removeAllServiceTotals = (serviceLine: any) => {
    const targetLine = groupedData?.find(
      (line: any) => line?.service_line_id === serviceLine
    );
    if (targetLine) {
      const serviceIdsToRemove = [
        ...(targetLine.services ?? []).map((s: any) => s.entity_id),
        ...(targetLine.service_groups ?? []).flatMap((group: any) =>
          (group.services ?? []).map((s: any) => s.entity_id)
        ),
      ];
      const filteredIds = selectedServiceIds?.filter(
        (id: any) => !serviceIdsToRemove.includes(id)
      );
      setSelectedServiceIds(filteredIds);
    }

    setGroupedData((prevData: any) =>
      prevData.filter(
        (item: any) => item.service_line_id !== groupData?.service_line_id
      )
    );
  };

  const serviceItems = [
    {
      key: "1",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Reset all service line numbers to default
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDelete(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Remove service line
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    setActiveRecord(null);
    setActiveType(null);
    setActiveServiceLineId(null);
    removeAllServiceTotals(groupData?.service_line_id);
    setConfirmDelete(false);
  };

  const confirmDeleteService = {
    visibility: confirmDelete,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmDelete(false)}
        heading="Remove service line from estimate"
        paragraph={
          <>
            This service line with all its services and items will be removed
            from this estimate. <br />
            <br />
            Are you sure you want to remove it?
          </>
        }
        btnText="Remove service line"
        btnApi={deleteFunction}
        loading={false}
        isArchivePopup={true}
      />
    ),
    width: 480,
    onCancel: () => setConfirmDelete(false),
  };

  return (
    <div className="serviceWrapBox">
      <Card
        className={`${groupData?.color} serviceLineWrap`}
        style={{ paddingLeft: "20px" }}
      >
        <h3>{groupData?.name}</h3>

        <InnerCard
          laborRate={groupData?.labor_rate}
          totalCost={groupData?.total_cost}
          totalPrice={groupData?.total_price}
          setGroupedData={setGroupedData}
          serviceLineId={groupData?.service_line_id}
          groupedData={groupedData}
          gmValue={groupData?.gross_margin_perc}
          setEstimateChanges={setEstimateChanges}
          apiData={apiData?.services_lines?.find(
            (item: any) => item?.service_line_id === groupData?.service_line_id
          )}
          serviceLineName={groupData?.name}
        />
        <div className="estimateDropdown">
          <Dropdown
            menu={{ items: serviceItems }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
                // setServiceLineIdRecord(groupData?.service_line_id);
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>
      </Card>

      {groupData?.service_groups?.length > 0 &&
        groupData?.service_groups?.map((serviceGroup: any) => {
          const visits = serviceGroup?.services?.map(
            (item: { visit: string }) => item.visit
          );
          const highestVisit = visits ? Math.max(...visits) : 1;

          const inHouse = serviceGroup?.services?.some(
            (service: any) => service.who_performs === "in_house"
          );
          const subContractor = serviceGroup?.services?.some(
            (service: any) => service.who_performs === "sub_contractor"
          );

          let totalSubServiceCost = 0;
          let totalSubServicePrice = 0;

          serviceGroup?.services?.forEach((service: any) => {
            totalSubServiceCost += service?.total_cost || 0;
            totalSubServicePrice += service?.total_price || 0;
          });

          return (
            <ServicesWithSub
              key={serviceGroup?.id}
              color={groupData?.color}
              serviceGroup={serviceGroup}
              inHouse={inHouse}
              subContractor={subContractor}
              highestVisit={highestVisit}
              totalSubServiceCost={totalSubServiceCost || 0}
              totalSubServicePrice={totalSubServicePrice || 0}
              companyId={companyId}
              setActiveRecord={setActiveRecord}
              setActiveType={setActiveType}
              setGroupedData={setGroupedData}
              groupIndex={groupIndex}
              groupedData={groupedData}
              groupData={groupData}
              setActiveServiceLineId={setActiveServiceLineId}
              setActiveServiceId={setActiveServiceId}
              setSelectedServiceIds={setSelectedServiceIds}
              setEstimateChanges={setEstimateChanges}
              apiData={apiData?.services_lines?.find(
                (item: any) =>
                  item?.service_line_id === groupData?.service_line_id
              )}
              serviceLineName={groupData?.name}
              serviceLineId={groupData?.service_line_id}
            />
          );
        })}

      {groupData?.services?.length > 0 &&
        groupData?.services?.map((serviceGroup: any, serviceIndex: number) => {
          const visits =
            dealsDetailData?.data?.start_date &&
            dealsDetailData?.data?.end_date &&
            serviceGroup?.frequency &&
            Math.round(
              calculateServiceIntervals(
                dealsDetailData?.data?.start_date,
                dealsDetailData?.data?.end_date,
                serviceGroup?.frequency
              )
            );

          return (
            <SimpleService
              key={serviceGroup?.id}
              serviceData={serviceGroup}
              setGroupedData={setGroupedData}
              serviceIndex={serviceIndex}
              visits={visits}
              color={groupData?.color}
              activeServiceLine={groupData}
              setActiveServiceLineId={setActiveServiceLineId}
              setActiveRecord={setActiveRecord}
              setActiveServiceId={setActiveServiceId}
              setActiveType={setActiveType}
              setSelectedServiceIds={setSelectedServiceIds}
              setEstimateChanges={setEstimateChanges}
              // updateTotals={(entityId: string, cost: number, price: number) => {
              //   setAllServiceTotals((prev) => ({
              //     ...prev,
              //     [entityId]: {
              //       total_cost: cost,
              //       total_price: price,
              //     },
              //   }));
              // }}
              apiData={
                apiData?.services_lines?.find(
                  (item: any) => item.name === groupData.name
                )?.services
              }
            />
          );
        })}

      {groupData?.materials?.length > 0 &&
        groupData?.materials?.map((matItem: any) => {
          return (
            <MatItems
              key={matItem?.id}
              color={groupData?.color}
              matItemData={matItem}
              setGroupedData={setGroupedData}
              serviceLineId={groupData?.service_line_id}
            />
          );
        })}

      {groupData?.line_items?.length > 0 &&
        groupData?.line_items?.map((lineItem: any) => {
          return (
            <LineItems
              key={lineItem?.id}
              color={groupData?.color}
              lineItemData={lineItem}
              setGroupedData={setGroupedData}
              serviceLineId={groupData?.service_line_id}
            />
          );
        })}

      <PopUp {...confirmDeleteService} />
    </div>
  );
}
